import React from "react";
import { ArrowDownUp, X } from "lucide-react";
import { TaskListItem } from "../../../api/requests";
import { Shimmer } from "../../../components/Shimmer/Shimmer";
import { formatDate, getStatusLabel } from "../requestDetailUtils";

export interface RequestDetailTaskListSidebarProps {
  isTaskListModalOpen: boolean;
  taskListSortDirection: "asc" | "desc";
  taskListModalItems: TaskListItem[];
  taskListModalLoading: boolean;
  taskList: TaskListItem[] | null;
  selectedTaskIndex: number;
  setTaskListSortDirection: React.Dispatch<React.SetStateAction<"asc" | "desc">>;
  handleCloseTaskListModal: () => void;
  handleTaskListModalScroll: (e: React.UIEvent<HTMLDivElement>) => void;
  handleSelectTaskFromModal: (taskId: string) => void | Promise<void>;
}

export const RequestDetailTaskListSidebar: React.FC<RequestDetailTaskListSidebarProps> = ({
  isTaskListModalOpen,
  taskListSortDirection,
  taskListModalItems,
  taskListModalLoading,
  taskList,
  selectedTaskIndex,
  setTaskListSortDirection,
  handleCloseTaskListModal,
  handleTaskListModalScroll,
  handleSelectTaskFromModal,
}) => (
  <>
    <div
      className={`detail-tasklist-backdrop ${isTaskListModalOpen ? "is-open" : ""}`}
      onClick={handleCloseTaskListModal}
    />
    <aside className={`detail-tasklist-modal ${isTaskListModalOpen ? "is-open" : ""}`}>
      <div className="detail-tasklist-modal-head">
        <h3>Задачи заявки</h3>
        <div className="detail-tasklist-modal-controls">
          <button
            type="button"
            className="detail-tasklist-sort-icon-btn"
            onClick={() =>
              setTaskListSortDirection((prev) => (prev === "desc" ? "asc" : "desc"))
            }
            aria-label={
              taskListSortDirection === "desc"
                ? "Сортировка: сначала новые"
                : "Сортировка: сначала старые"
            }
            title={
              taskListSortDirection === "desc"
                ? "Сортировка: сначала новые"
                : "Сортировка: сначала старые"
            }
          >
            <ArrowDownUp size={16} />
          </button>
          <button
            type="button"
            className="detail-tasklist-close"
            onClick={handleCloseTaskListModal}
            aria-label="Закрыть список задач"
          >
            <X size={18} />
          </button>
        </div>
      </div>
      <div className="detail-tasklist-modal-list" onScroll={handleTaskListModalScroll}>
        {taskListModalItems.map((task) => (
          <button
            key={task.id}
            type="button"
            className={`detail-tasklist-item ${
              taskList?.[selectedTaskIndex]?.id === task.id ? "is-selected" : ""
            }`}
            onClick={() => handleSelectTaskFromModal(task.id)}
          >
            <span className="detail-tasklist-item-status">{getStatusLabel(task.status)}</span>
            <span className="detail-tasklist-item-date">{formatDate(task.startDateTime)}</span>
          </button>
        ))}
        {taskListModalLoading && (
          <div className="detail-tasklist-loading">
            <Shimmer rows={2} />
          </div>
        )}
      </div>
    </aside>
  </>
);
